// ============================================================
// Student Constants
// ============================================================

export const STUDENT_STATUSES = [
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Inactive', value: 'INACTIVE' },
  { label: 'Transferred', value: 'TRANSFERRED' },
  { label: 'Passed Out', value: 'PASSED_OUT' },
  { label: 'Dropped Out', value: 'DROPPED_OUT' },
  { label: 'Deleted', value: 'DELETED' },
];

export const ENROLLMENT_STATUSES = [
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Inactive', value: 'INACTIVE' },
  { label: 'Completed', value: 'COMPLETED' },
  { label: 'Transferred', value: 'TRANSFERRED' },
  { label: 'Dropped Out', value: 'DROPPED_OUT' },
];

// Used in filters
export const GENDERS_FILTER = [
  { label: 'Male', value: 'MALE' },
  { label: 'Female', value: 'FEMALE' },
  { label: 'Other', value: 'OTHER' },
];

// Used in forms
export const GENDERS = ['Male', 'Female', 'Other'];

export const BLOOD_GROUPS = ['A+', 'A-', 'B+', 'B-', 'O+', 'O-', 'AB+', 'AB-'];

// Used in filters
export const RELIGIONS_FILTER = ['HINDU', 'MUSLIM', 'CHRISTIAN', 'SIKH', 'BUDDHIST', 'JAIN', 'OTHER'];
export const CATEGORIES_FILTER = ['GENERAL', 'OBC', 'SC', 'ST', 'OTHER'];
export const CASTES_FILTER = ['GENERAL', 'OBC', 'SC', 'ST', 'OTHER'];
export const ADMISSION_TYPES_FILTER = ['NEW', 'REGULAR', 'TRANSFER', 'RTE', 'OTHER'];

import { getReligions, getCategoriesForReligion, getAllCastes } from './demographicsData';

// Used in forms
export const RELIGIONS = getReligions();
export const CATEGORIES = getCategoriesForReligion();
export const CASTES = getAllCastes();

export const ADMISSION_TYPES = ['New', 'Regular', 'Transfer'];

export const NATIONALITIES = ['INDIAN', 'OTHER'];

export const SORT_BY_OPTIONS = [
  { label: 'First Name', value: 'first_name' },
  { label: 'Last Name', value: 'last_name' },
  { label: 'Admission No.', value: 'admission_no' },
  { label: 'SR Number', value: 'sr_number' },
  { label: 'Date of Birth', value: 'date_of_birth' },
  { label: 'Admission Date', value: 'admission_date' },
  { label: 'Roll Number', value: 'roll_number' },
  { label: 'Class Name', value: 'class_name' },
  { label: 'Section Name', value: 'section_name' },
  { label: 'Created At', value: 'created_at' },
];

export const SORT_ORDER_OPTIONS = [
  { label: 'Ascending (A-Z / 1-9)', value: 'asc' },
  { label: 'Descending (Z-A / 9-1)', value: 'desc' },
];
